import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { AnchorNavSticky } from 'site-modules/shared/components/anchor-nav-sticky/anchor-nav-sticky';

import './brand-subnav.scss';

export function BrandSubnav({ items = undefined, className = null, isMobile = false }) {
  return (
    <div className={classnames('brand-subnav', className)}>
      <AnchorNavSticky
        title={null}
        navList={items}
        isMobile={isMobile}
        containerClassName="container px-0"
        navWrapperClassName={null}
        anchorNavContentClassName="w-100"
        itemClassName="pos-r my-0_5 ms-1_25"
        linkClassName="py-0_75 px-1_5 border-0 text-blue-40 fw-medium"
        hasSeparator={false}
      />
    </div>
  );
}

BrandSubnav.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      hash: PropTypes.string,
    })
  ),
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};
